import { useEffect, useState } from 'react'
import TextInput from '../TextInput'
import Popover from 'react-awesome-popover'

import './style.scss'
import { useTranslation } from 'react-i18next'

const SkillsAssetment = (props: any) => {
  const { t } = useTranslation()

  const placeholders = [
    t('Enter Assessment Criteria'),
    t('Enter Description of Assessment Criteria'),
    t('Enter Score for Criteria'),
  ]

  const [horizontalHeader, setHorizontalHeader] = useState(
    props.horizontalHeaderValues
      ? props.horizontalHeaderValues
      : [
          t('Score Criteria'),
          t('Score for Criteria'),
          t('Description of Scoring Criteria'),
        ],
  )
  const [tableData, setTableData] = useState(
    props.tableValues
      ? props.tableValues
      : [
          { text: '', score: 1, keyword_scores: {} },
          { text: '', score: 1, keyword_scores: {} },
        ],
  )
  const [controlColumnCount, setControlColumnCount] = useState(
    props.columnCount ? props.columnCount : props.horizontalHeaderValues.length,
  )
  const [controlRowCount, setControlRowCount] = useState(1)

  useEffect(() => {
    setControlRowCount(Math.ceil(props.tableValues.length / 3))
    setControlColumnCount(3)
  }, [props.tableValues])

  useEffect(() => {
    if (props.horizontalHeaderValues.length === props.columnCount) {
      let temp = [...props.horizontalHeaderValues]
      temp.unshift('')
      setHorizontalHeader(temp)
    }
  }, [])

  useEffect(() => {
    props.onAnswerKeyTableChange(tableData, controlRowCount, controlColumnCount)
  }, [tableData])

  const onRowCellChange = (value: any, index: any) => {
    // if (value?.length < tableData[index]?.text?.length) {
    let trimValue = value

    let temp = [...tableData]
    const regEx = new RegExp(
      /^(\d+(?:\.\d+)?)(?:\s?-\s?(\d+(?:\.\d+)?))?(\D*?)$/gm,
    )
    if (trimValue && index === 2) {
      if (regEx.test(trimValue)) {
        temp[index].text = trimValue
      }
    } else if (trimValue) {
      temp[index].text = trimValue
    } else {
      temp[index].text = ''
    }
    setTableData(temp)
    // }
  }

  const handleRowCellPaste = (event: any) => {
    let pastedContent = event.clipboardData.getData('text')
    let splitRows = pastedContent.split('\n')
    let pastedTableBodyData: any = []
    if (splitRows.length && splitRows[0].split('\t').length > 1) {
      splitRows.forEach((row: any, index: any) => {
        let splitCells = row.split('\t')
        if (index === 0 && splitCells.length) {
          let difference = splitCells.length - controlColumnCount
          if (difference > 0) {
            let updatedHorizontalHeader = [...horizontalHeader]
            for (let i = 0; i < difference; i++) {
              updatedHorizontalHeader.push('')
            }
            setHorizontalHeader(updatedHorizontalHeader)
          }
          setControlColumnCount(splitCells.length)
        }
        splitCells.forEach((cell: any) => {
          pastedTableBodyData.push({
            text: cell,
            score: 1,
            keyword_scores: {},
          })
        })
      })
      setTableData(pastedTableBodyData)
    }
  }

  const onCellKeywordChange = (value: any, index: any) => {
    let temp = [...tableData]
    temp[index].keyword_scores = value
    setTableData(temp)
  }

  const onCellScoreChange = (value: any, index: any) => {
    let temp = [...tableData]
    temp[index].score = value
    setTableData(temp)
  }

  const addRow = (targetIndex: any) => {
    let tempTableData = [...tableData]
    if (targetIndex || targetIndex === 0) {
      for (
        let i = (targetIndex + 1) * controlColumnCount;
        i < controlColumnCount * (targetIndex + 2);
        i++
      ) {
        tempTableData.splice(i, 0, {
          text: '',
          score: 1,
          keyword_scores: {},
        })
      }
    } else {
      for (let i = 1; i <= controlColumnCount; i++) {
        tempTableData.push({
          text: '',
          score: 1,
          keyword_scores: {},
        })
      }
    }
    setTableData(tempTableData)
    setControlRowCount((data: any) => data + 1)
  }

  const removeRow = (targetRow: any) => {
    let tempTableData = [...tableData]
    let startIndex = targetRow * controlColumnCount
    for (let i = 1; i <= controlColumnCount; i++) {
      tempTableData.splice(startIndex, 1)
    }
    setTableData(tempTableData)
    setControlRowCount((data: any) => data - 1)
  }

  const divideArray = () => {
    let temp = [...tableData]
    const result = new Array(Math.ceil(temp.length / controlColumnCount))
      .fill(null)
      .map(_ => temp.splice(0, controlColumnCount))

    return result
  }

  const getTableBody = () => {
    let body = []
    body = divideArray().map((row, rowIndex: any) => (
      <tr className="match-row">
        {row.map((cell, cellIndex: any) => (
          <td className="match-input-wrapper remove-up-down-arrow">
            <TextInput
              disabled={props.viewOnly}
              value={cell.text}
              inputChange={(event: any) =>
                onRowCellChange(
                  event.target.value,
                  cellIndex + controlColumnCount * rowIndex,
                )
              }
              // inputType={cellIndex === 0 && "number"}
              onPaste={handleRowCellPaste}
              placeholder={placeholders[cellIndex]}
            />
            {props.scoredBy.value === 'enhanced_keywords' && (
              <div className="quiz-table-cell-toolbar">
                <Popover
                  placement={'top-end'}
                  overlayColor={'rgba(0,0,0,0)'}
                  className="custom-popover"
                  arrowProps={{
                    className: 'quiz-table-popover-arrow',
                  }}
                  arrow={false}
                >
                  {!props.viewOnly && (
                    <button
                      className="toolbar-btn cell-property-btn"
                      title="Edit keywords and score"
                    >
                      <i className="icon-edit-line toolbar-icon" />
                    </button>
                  )}
                  <div className="popover-box">
                    <TextInput
                      disabled={props.viewOnly}
                      useTextArea
                      label="Keywords"
                      value={cell.keyword_scores}
                      inputChange={(event: any) =>
                        onCellKeywordChange(
                          event.target.value,
                          cellIndex + controlColumnCount * rowIndex,
                        )
                      }
                    />
                    <div className="half-clearfix" />
                    <TextInput
                      disabled={props.viewOnly}
                      label="Score"
                      inputType="number"
                      value={cell.score}
                      inputChange={(event: any) =>
                        onCellScoreChange(
                          event.target.value,
                          cellIndex + controlColumnCount * rowIndex,
                        )
                      }
                    />
                  </div>
                </Popover>
              </div>
            )}
          </td>
        ))}
        {!props.viewOnly && (
          <div className="quiz-table-row-toolbar">
            <button
              onClick={() => {
                addRow(rowIndex)
              }}
              className="toolbar-btn row-add-btn"
              title="Add row"
            >
              <i className="icon-add toolbar-icon" />
            </button>
            {controlRowCount > 1 && (
              <button
                onClick={() => {
                  removeRow(rowIndex)
                }}
                className="toolbar-btn row-remove-btn"
                title="Remove row"
              >
                <i className="icon-delete toolbar-icon" />
              </button>
            )}
          </div>
        )}
      </tr>
    ))
    return body
  }

  return (
    <div className="quiz-table-master-container">
      <div className="quiz-table-wrapper">
        <table className="match-editor">
          <thead className="">
            {horizontalHeader?.map((value: any, index: any) => (
              <th className="match-header-wrapper ">{<div>{value}</div>}</th>
            ))}
          </thead>
          <tbody>{getTableBody()}</tbody>
        </table>
      </div>
    </div>
  )
}

export default SkillsAssetment
